import React from 'react'
import { Box, Typography } from '@mui/material'
import { onDark } from '../theme'

const Fact = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, py: 0.5 }}>
    <Typography variant="subtitle1" sx={{ color: onDark.secondary }}>
      {label}
    </Typography>
    <Typography variant="subtitle1" sx={{ color: onDark.primary, fontWeight: 600, textAlign: 'right' }}>
      {value}
    </Typography>
  </Box>
)

export default Fact
